import { ColumnModel } from '../primitive/column.model';

/**
 * Model options for tables.
 * sortColumn:   The column that should be initially used to sort.
 * reverseSort:  Should the initial sort order be inverted?
 * columns:      An array of ColumnModels. Each ColumnModel defines a column in the table.
 */
export class TableModelOptions {
    public readonly sortColumn: string;
    public readonly reverseSort: boolean;
    public readonly columns: ColumnModel[];
    public readonly initialSelectRow: number;
    public readonly showCheckboxes: boolean;
    public readonly highlightSelectedRow: boolean;
    public constructor({
        columns,
        sortColumn = '',
        reverseSort = false,
        selectedRow = 0,
        showCheckboxes = false,
        highlightSelectedRow = true,
    }: {
        columns: ColumnModel[];
        sortColumn?: string;
        reverseSort?: boolean;
        selectedRow?: number;
        showCheckboxes?: boolean;
        highlightSelectedRow?: boolean;
    }) {
        this.columns = columns;
        this.sortColumn = sortColumn;
        this.reverseSort = reverseSort;
        this.initialSelectRow = selectedRow;
        this.showCheckboxes = showCheckboxes;
        this.highlightSelectedRow = highlightSelectedRow;
    }
}
